import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookmarkComponent } from './bookmark.component';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { DxCheckBoxModule, DxDataGridModule, DxLoadPanelModule, DxPopupModule,  DxScrollViewModule, DxTextAreaModule } from 'devextreme-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [BookmarkComponent],
  exports: [BookmarkComponent],

  imports: [
    CommonModule, DevEpressCommonModule, DxPopupModule, DxScrollViewModule, DxTextAreaModule,
    DxLoadPanelModule, DxDataGridModule, DxCheckBoxModule,DxScrollViewModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class BookmarkModule { }
